import { render } from "./invalid-receipt-alert.vue?vue&type=template&id=d1c9eca8"
import script from "./invalid-receipt-alert.vue?vue&type=script&lang=js"
export * from "./invalid-receipt-alert.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__